import { environment } from './../../../environments/environment';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CnpjService {

  constructor(private http: HttpClient) { }


  public getCnpjInfo(cnpj: string) {
    return this.http.get<any>(`${environment.corp.url}/cnpj/${cnpj}`);
  }
}
